import { createSlice } from '@reduxjs/toolkit'

const tabSlice = createSlice({
  name: 'tab',
  initialState: {
    isCollapse: false,
    activeOpenKeys: []
  },
  reducers: {
    openMenu: state => {
      // state.isCollapse = false
    },
    closeMenu: state => {
      // state.isCollapse = true
    }
  }
})
export const { openMenu, closeMenu } = tabSlice.actions
export default tabSlice.reducer
